import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { IonButton } from "@ionic/react";

export default function PublicDeleteAccountPage() {
  return (
    <PageContainer className="h-full w-full app-bar-bottom-padding overflow-y-auto no-scrollbar">
      <PageTitleComponent
        title="Delete Your NutriCoach Account"
        description="Follow the steps below to remove your account. These instructions satisfy App Store and Google Play data deletion requirements."
      />

      <div className="px-4 pb-16 max-w-3xl mx-auto text-sm text-gray-700 space-y-10">
        <section className="space-y-3">
          <h3 className="text-lg font-semibold text-gray-900">
            Before You Begin
          </h3>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Make sure you can sign in to the NutriCoach app with the account
              you want to delete.
            </li>
            <li>
              Deleting your account permanently removes your meal plans,
              preferences, and all personal data.
            </li>
            <li>The deletion workflow is the same on iOS and Android.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h3 className="text-lg font-semibold text-gray-900">
            Step-by-Step Instructions
          </h3>
          <ol className="list-decimal list-inside space-y-3">
            <li>Open the NutriCoach app and sign in to your account.</li>
            <li>Tap the profile tab in the bottom navigation bar.</li>
            <li>
              Open <strong>Settings</strong> from the profile screen.
            </li>
            <li>
              Scroll down and tap <strong>Delete Account</strong>.
            </li>
            <li>
              Press and hold the <strong>Hold to Delete Account</strong> button
              for 5 seconds to confirm.
            </li>
            <li>
              When the confirmation alert appears, choose{" "}
              <strong>Yes, Delete</strong> to finalize the deletion.
            </li>
          </ol>
        </section>

        <section className="space-y-3">
          <h3 className="text-lg font-semibold text-gray-900">
            After Deletion
          </h3>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Your account and all associated data are permanently removed.
            </li>
            <li>
              You will be signed out immediately and redirected to the login
              screen.
            </li>
            <li>
              If you reinstall the app or sign in again later, you will need to
              create a new account.
            </li>
          </ul>
        </section>

        <section className="space-y-3">
          <h3 className="text-lg font-semibold text-gray-900">
            Need Additional Help?
          </h3>
          <p>
            If you experience issues while deleting your account, contact our
            support team at{" "}
            <a
              className="text-primary-500 underline"
              href="mailto:dev.nutricoach@gmail.com"
            >
              dev.nutricoach@gmail.com
            </a>{" "}
            and include the email address linked to your NutriCoach profile.
          </p>
        </section>

        <section className="space-y-3">
          <h3 className="text-lg font-semibold text-gray-900">
            Ready to Sign In Again?
          </h3>
          <p>
            Return to the login screen whenever you need to access NutriCoach
            with your existing credentials or to create a new account.
          </p>
          <div className="flex justify-center">
            <IonButton
              routerLink="/login"
              color="primary"
              shape="round"
              expand="block"
              className="max-w-xs w-full normal-case font-semibold"
            >
              Go to Login
            </IonButton>
          </div>
        </section>
      </div>
    </PageContainer>
  );
}
